// @flow

import * as React from 'react'
import type { Node } from 'react'
import { Toaster as Sonner } from 'sonner'

/** Sonner (https://ui.shadcn.com/docs/components/radix/sonner) */
export function Toaster(): Node {
  return (
    <Sonner position="bottom-center" richColors closeButton />
  )
}

export default Toaster
